/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {formatDate} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FabMessageService} from '@fabric/components/message';
import {DISMISS_MSG} from '../../../common/constants';
import {getDefaultYearRange} from '../../../core/helpers/generic-helpers';
import {StateService} from '../../../core/state/state.service';
import {GlobalScenario} from '../../../models/global-scenario-dto.model';
import {ExcelExportService} from '../../../services/excel-export.service';
import {ReportService} from '../../../services/report.service';

@Component({
    selector: 'app-run-rates-dates-report',
    templateUrl: './run-rates-dates-report.component.html',
    styleUrl: './run-rates-dates-report.component.scss',
    standalone: false
})
export class RunRatesDatesReportComponent implements OnInit {
  showSpinner: boolean;
  selectedSourceType: number;
  selectedScenarios: any[] = [];
  selectedGlobalScenario: GlobalScenario;

  startYear: number;
  endYear: number;
  yearRange: number[];
  aggregateTos: boolean;
  removeRecidNa: boolean;
  highRunRate: number;


  constructor(public snackBar: FabMessageService,
              public reportService: ReportService,
              public readonly excelService: ExcelExportService,
              public stateService: StateService) {
  }

  ngOnInit(): void {
    this.getYearRange();
    this.selectedSourceType = 0;
    this.highRunRate = 200;
    this.aggregateTos = true;
    this.removeRecidNa = false;
  }

  /**
   * sets the scenarios returned by the event to the selected scenarios
   * @param event
   */
  selectScenarios(event: any): void {
    this.selectedScenarios = event.selectedScenarios;
  }

  /**
   * sets the scenarios returned by the event to the selected scenarios
   * @param event
   */
  selectGlobalScenario(event: any): void {
    this.selectedScenarios = event.memberScenarios;
    this.selectedGlobalScenario = event.globalScenario;
  }

  /**
   * Resets selected scenarios on source change
   */
  onSourceChange(): void {
    this.selectedScenarios = [];
    this.selectedGlobalScenario = null;
  }


  /**
   * Gets the year range for the reports
   */
  getYearRange(): void {
    const {yearRange, startYear, endYear} = getDefaultYearRange();
    this.yearRange = yearRange;
    this.startYear = startYear;
    this.endYear = endYear;
  }

  /**
   * Gets the run rates and dates audit report
   */
  getReport(): void {
    this.showSpinner = true;
    const currDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    const idList = this.selectedScenarios.map(scenario => scenario.vehScenId);
    let scenarioString: string;
    if (this.selectedSourceType == 1) {
      scenarioString = this.selectedGlobalScenario.id.toString();
    } else {
      scenarioString = idList.length > 1 ? idList.sort()[0] + "-" + idList.sort()[idList.length - 1] : idList[0]?.toString();
    }
    const fileName = 'AuditRunRatesDates_' + scenarioString + "_" + currDate;
    const idString = idList.join(',');
    this.reportService.getRunRatesDatesAuditReport(idString, this.startYear, this.endYear, this.stateService.getUserGmid(),
      this.aggregateTos, this.removeRecidNa, this.highRunRate).subscribe({
      next: (response: any) => {
        this.excelService.exportToExcelFromServer(response, fileName);
      },
      error: (error: any) => {
        this.showSpinner = false;
        this.snackBar.displayError(error, DISMISS_MSG);
      },
      complete: () => {
        this.showSpinner = false;
      }
    });
  }
}
